module.exports = __webpack_public_path__ + "img/Sunny-Geevarghese.be7f39c0.jpg";